var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "invite-rules-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow01.png"),
                        alt: "",
                      },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "rules-content" }, [
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-0.5px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k179"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k180"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k181"))),
            ]),
            _c("MyPLabel", {
              staticClass: "rules-row right-read",
              attrs: {
                str: `3. ${_vm.$t("lang.commonM.k182")}`,
                numsOption: [{ value: _vm.limitTime }],
              },
            }),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("4. " + _vm._s(_vm.$t("lang.commonM.k183"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("5. " + _vm._s(_vm.$t("lang.commonM.k184"))),
            ]),
            _vm.baseInfo && _vm.baseInfo.userRankRewardDTO
              ? _c("div", { staticClass: "zone-block" }, [
                  _c("div", { staticClass: "zone-item right-align" }, [
                    _vm.baseInfo.userRankRewardDTO.areaDesc === "Brazil"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k174")))])
                      : _vm.baseInfo.userRankRewardDTO.areaDesc ===
                        "Latin America"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k175")))])
                      : _vm.baseInfo.userRankRewardDTO.areaDesc ===
                        "Middle East"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k176")))])
                      : _vm.baseInfo.userRankRewardDTO.areaDesc === "Indonesia"
                      ? _c("div", [_vm._v(_vm._s(_vm.$t("lang.commonM.k177")))])
                      : _c("div", [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k178"))),
                        ]),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "rules-block" },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k170"))),
            ]),
            _c("MyPLabel", {
              staticClass: "rules-row right-read",
              attrs: {
                str: `1. ${_vm.$t("lang.commonM.k185")}`,
                numsOption: [{ value: _vm.limitTime }],
              },
            }),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k186"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k187"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("4. " + _vm._s(_vm.$t("lang.commonM.k188"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("5. " + _vm._s(_vm.$t("lang.commonM.k189"))),
            ]),
            _vm.baseInfo
              ? _c(
                  "div",
                  { staticClass: "list-table" },
                  [
                    _c("div", { staticClass: "list-fields right-read" }, [
                      _c("div", { staticClass: "field field1" }, [
                        _vm._v(_vm._s(_vm.$t("lang.kissGf.ranking"))),
                      ]),
                      _c("div", { staticClass: "field field2" }, [
                        _vm._v(" " + _vm._s(_vm.$t("lang.mybean.bonus")) + " "),
                        _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
                      ]),
                    ]),
                    _vm._l(_vm.baseInfo.rankRewardDTOs, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "list-fields right-read" },
                        [
                          _c("div", { staticClass: "bd-field field1" }, [
                            _vm._v(_vm._s(item.range)),
                          ]),
                          _c("div", { staticClass: "bd-field field2" }, [
                            _vm._v(_vm._s(item.rewardCount)),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-0.5px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k190"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k191"))),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k192")))]),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k193")))]),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k194"))),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k195")))]),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k196")))]),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k197")))]),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k198"))),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k199")))]),
            ]),
            _c("p", { staticClass: "rules-row sub-row right-read" }, [
              _c("span", [_vm._v("•")]),
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k200")))]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-0.5px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.commonM.k201"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("1. " + _vm._s(_vm.$t("lang.commonM.k202"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("2. " + _vm._s(_vm.$t("lang.commonM.k203"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v("3. " + _vm._s(_vm.$t("lang.commonM.k204"))),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }